/**
 * The module draft's assessment weight ledger, and the badge total read from it.
 *
 * @module components/studio/useAssessmentLedger
 */

import { useMemo } from "react";

import type { Module, Programme } from "@/types";

import { assessmentWeightOf, draftWeightLedger } from "./module-editor-model";

export function useAssessmentLedger(
  programme: Pick<Programme, "modules" | "versions"> | undefined,
  moduleDraft: Module | null,
) {
  const assessmentLedger = useMemo(
    () => draftWeightLedger(programme, moduleDraft),
    [programme, moduleDraft],
  );
  return { assessmentLedger, assessmentWeight: assessmentWeightOf(assessmentLedger, moduleDraft) };
}
